import { FC } from "react";
import { Skeleton } from "@shadcn/components/ui/skeleton";
import { QuestionSkeleton } from "./QuestionSkeleton";

export const FormSkeleton: FC = () => {
  return (
    <div className="mx-auto max-w-xl px-4 py-8">
      <div className="space-y-12">
        <Skeleton className="h-10 w-3/4" />
        {[1, 2, 3].map((i) => <QuestionSkeleton key={i} />)}
        <Skeleton className="h-10 w-24" />
      </div>
    </div>
  );
};
